import type { EvalTaskSpec } from '@sbc/domain-models/agents';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';

import { ApiError } from '@/lib/api/client';
import { useAddTask } from '@/lib/api/eval-suites';

import { TaskEditor } from './task-editor';
import { TASK_TEMPLATE } from './task-yaml';

export function TaskNewPage({ suiteId }: { suiteId: string }) {
  const navigate = useNavigate();
  const addTask = useAddTask(suiteId);
  const [error, setError] = useState<string | null>(null);

  const back = () => navigate({ to: '/evals/suites/$suiteId', params: { suiteId } });

  const onSubmit = (spec: EvalTaskSpec) => {
    setError(null);
    addTask.mutate(spec, {
      onSuccess: back,
      onError: (caught) =>
        setError(caught instanceof ApiError ? caught.message : 'Could not create the task.'),
    });
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold tracking-tight">New task</h1>
      <TaskEditor
        initialText={TASK_TEMPLATE}
        submitting={addTask.isPending}
        submitLabel="Create task"
        error={error}
        onSubmit={onSubmit}
        onCancel={back}
      />
    </div>
  );
}
